import { IconFolder } from '@tabler/icons-react'
import { themeCfg } from '../../theme/theme'
import { Group, HoverCard, ScrollArea, Tabs, Tooltip } from '@mantine/core'
import { useState, useTransition } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface CustomProps {
  options?: any
  blur?: boolean
  breakpoint?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
}

const AppTabMenu = ({
  options,
  blur = false,
  breakpoint = 'lg',
}: CustomProps) => {
  const navigate = useNavigate()
  const location = useLocation
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<string | null>(
    window.location.pathname,
  )

  const handleTabChange = (value: string | null) => {
    setActiveTab(value)
    if (value !== window.location.pathname) {
      navigate(value)
    }
  }

  if (options?.length > 0)
    return (
      <Tabs
        w="100%"
        value={activeTab}
        onChange={(value) => handleTabChange(value)}
        data-app-blur={blur}
      >
        <Tabs.List>
          {options?.map((option, idx) => {
            const active =
              !option?.disabled &&
              window.location.pathname.includes(option?.path)
            const selected =
              !option?.disabled &&
              window.location.pathname.includes(option?.path)
            return (
              <Tooltip
                hiddenFrom={breakpoint}
                position="top"
                label={t(option?.id)}
              >
                <Tabs.Tab
                  c={active ? 'moure-blue' : 'gray'}
                  // fz={16}
                  color="moure-orange"
                  value={option?.path || '-'}
                  disabled={option?.disabled}
                  component="button"
                  aria-active={active}
                  // leftSection={<IconFolder />}
                >
                  <Group visibleFrom={breakpoint}>{t(option?.id)}</Group>
                  <Group hiddenFrom={breakpoint}>
                    {t(option?.id)
                      .split(' ')
                      .map((word) => word[0])
                      .join('')
                      .toUpperCase()}
                  </Group>
                </Tabs.Tab>
              </Tooltip>
            )
          })}
        </Tabs.List>
      </Tabs>
    )
  return null
}

export default AppTabMenu
